import { DashboardAuthCallbackPage } from "@dashboard/components/auth-flow/AuthCallbackPage"
import { createFileRoute, redirect } from "@tanstack/react-router"
import { dashboardAppHostRedirectUrl } from "@utils/dashboard-host"
import { currentRequestHostname } from "@utils/dashboard-host-runtime"

export const Route = createFileRoute("/auth/callback")({
  beforeLoad: async ({ location }) => {
    const redirectHref = dashboardAppHostRedirectUrl(await currentRequestHostname(), location.href)
    if (redirectHref) throw redirect({ href: redirectHref })
  },
  component: DashboardAuthCallbackPage,
})
